import {
  getPatientFile,
  patientWithDoctor,
  patientWithProfile,
  getInfoByPhone,
  getSummaryTodo,
  getNextFollowupInfo
} from '@/api/patientFile'
import { getDoingWorkOrderIdByUserId } from '@/api/workPlace/workOrder'
// import { maskPhoneNumber } from '@/utils'
import { message } from 'ant-design-vue'

// 患者档案数据
const state = {
  loading: false,
  // 0不展示 1展示弹窗 2展示缩小
  status: 0,
  // 当前查询的绑定信息
  bindUser: {
    // 医生信息
    doctorInfo: {},
    // 就诊人信息
    profileInfo: {}
  },
  // 患者类型- 0:预建档患者，1:普通患者
  patientType: 1,
  // 患者 和 医生信息（接口返回内容）
  info: {
    prePatientId: 0,
    ucPatientId: 6319646,
    patientId: '1000894599',
    photo: '',
    name: '施小美',
    gender: 0,
    age: '20',
    birthDate: '1999-1-1',
    idCard: '37171231231231230000',
    phone: '13000000001',
    phoneNum: 3,
    accountStatus: 0,
    status: 1,
    region: '杭州市',
    address: '中国浙江省杭州市滨江区滨安路1168号',
    registerTime: '1999-1-2',
    userSource: '扫码注册',
    patientProfiles: [
      {
        id: 2,
        patientProfileName: '22',
        relation: 2,
        relationName: '爱人',
        age: '22',
        gender: 0
      }
    ],
    doctors: [
      {
        ucDoctorId: 1,
        doctorId: 1,
        doctorName: 'doctorName',
        departmentId: 1,
        departmentName: '医生科室',
        hospitalId: 1,
        hospitalName: '杭州市第一人民医院滨江二院江二院江二院',
        titleId: 1,
        titleName: 'titleName',
        source: 1,
        sourceName: 'BD推荐',
        bindTime: '01-11 23:42:42'
      }
    ],
    patientLabels: [
      {
        configGroupCode: '123',
        id: 1,
        labelName: '标签1',
        labelId: 1
      },
      {
        configGroupCode: '123',
        id: 2,
        labelName: '标签2',
        labelId: 2
      }
    ],
    recomCnt: null,
    recomBuyCnt: null,
    recomBuyRate: null,
    recomSalesRate: null
  },
  // 协同备注
  remarkInfoResponse: {
    remarkTime: '2025-12-13',
    remarkPersonTypeStr: 'BD',
    id: 0,
    remarkId: '',
    remarkPersonType: 0,
    remarkPersonName: '雨雨雨',
    beRemarkContent:
      '病情描述病情描述病情描述病情描述病情描述，病情描述病情描述病。情描述病情描述病情描述病情描，述病情描述病情描述病情描述病情描述病情描述病情描述病情描述病情描述病情描，述病情描述病情描述病情描述病情描述；'
  },
  // 病程阶段
  disease: {
    patientId: 0,
    doctorId: 0,
    // 病程阶段 0-初诊 1-复诊
    diseaseStage: 0,
    diseaseCnt: 0
  },
  // 病程记录列表中 当前激活的问诊
  diagnosisPattern: {},
  // 工单ID
  workOrderId: '',
  dictionary: [], // 存储多个患者档案的初始数据
  activePatientId: '', //当前激活的患者id
  // 患者档案待办
  todoNums: {
    Prescription: 0,
    MedicalRecord: 0,
    FollowUpVisit: 0,
    Visits: 0,
    Platform: 0
  },
  nextFollowupTime: {} //下次回访时间
}
const mutations = {
  SET_LOADING(state, loading = false) {
    state.loading = loading
  },
  SET_WORK_ID(state, workOrderId) {
    state.workOrderId = workOrderId
  },
  SET_STATE(state, status) {
    state.status = status
  },
  SET_REMARK(state, remark) {
    state.remarkInfoResponse = remark
  },
  SET_NEXT_FOLLOWUP_TIME(state, nextFollowupTime) {
    state.nextFollowupTime = nextFollowupTime
  },
  SET_INFO(state, info) {
    state.info = info
  },
  SET_DISEASE(state, disease) {
    state.disease = disease
  },
  SET_PATIENT_TYPE(state, patientType) {
    state.patientType = patientType
  },
  /**
   * 绑定当前医生就诊人患者
   * @param {object} users 包含如下
   * profileId
   * doctorId
   */
  SET_BIND_USER(state, users) {
    const info = state.info
    let [doctorInfo, profileInfo] = [{}, {}]
    // NOTE: 预注册没有绑定关系
    // 默认就诊人
    profileInfo = (info?.patientProfiles && info?.patientProfiles[0]) || {}
    // 传进来有 就诊人
    if (users?.profileId && info?.patientProfiles) {
      profileInfo = info.patientProfiles.find(f => `${f.id}` === `${users?.profileId}`) || {}
    }
    // 默认的医生
    doctorInfo = (info?.doctors && info?.doctors[0]) || {}
    if (users?.doctorId && info?.doctors) {
      doctorInfo = info.doctors.find(f => `${f.doctorId}` === `${users?.doctorId}`) || {}
    }
    // NOTE: 最终数据绑定
    // 绑定医生ID
    state.bindUser.doctorInfo = doctorInfo
    // 就诊人
    state.bindUser.profileInfo = profileInfo
  },
  SET_DIAGNOSIS(state, diagnosis) {
    state.diagnosisPattern = diagnosis
  },
  // 更新患者档案初始数据,将原来预建档信息替换成当前患者信息
  UPDATE_DICCTIONARY(state, payload) {
    const { prePatientId, matchPatientInfo } = payload || {}
    if (!prePatientId || !matchPatientInfo?.patientId) {
      return message.error('参数异常')
    }
    const matchPatientId = matchPatientInfo.patientId
    const index = state.dictionary.findIndex(f => f.key === prePatientId)
    if (index !== -1) {
      state.dictionary[index].key = matchPatientId
      state.dictionary[index].value = matchPatientInfo
      state.dictionary[index].value.name = state?.info?.name || ''
      state.activePatientId = matchPatientInfo.patientId
      // 去重dictionary数组，确保key唯一
      const seen = new Set()
      state.dictionary = state.dictionary.filter(item => {
        if (seen.has(item.key)) {
          return false
        }
        seen.add(item.key)
        return true
      })
    }
  },
  // 存储多个患者档案的初始数据
  SET_DICCTIONARY(state, dictionary) {
    const item = state.dictionary.find(f => f.key === dictionary.key)
    if (!item) {
      if (!dictionary.name && !dictionary.nickName) {
        dictionary.value.name = state?.info?.name || ''
      }
      state.dictionary.push(dictionary)
    }
  },
  CLEAR_DICCTIONARY(state) {
    state.dictionary = []
  },
  // 当前激活的患者id
  SET_ACTIVE_PATIENT_ID(state, payload) {
    state.activePatientId = payload
  },
  // 单个更新待办
  SET_TODO_NUM(state, { type, count }) {
    state.todoNums[type] = count
  },
  // 批量更新待办
  SET_TODO_NUMS_BATCH(state, newTodoNums) {
    state.todoNums = {
      ...state.todoNums,
      ...newTodoNums
    }
  },
  // 重置待办
  RESET_TODO_NUMS(state) {
    state.todoNums = {
      Prescription: 0,
      MedicalRecord: 0,
      FollowUpVisit: 0,
      Visits: 0,
      Platform: 0
    }
  }
}
const actions = {
  /**
   * 当前患者档案关联工单
   * 例如：用户池进入，如有关联工单默认取第一个
   * 处理中工单点患者头像，默认携带工单ID
   */
  async getWorkOrderId(context, workOrderId) {
    let Wid = workOrderId
    // 判断没有 workOrderId
    const ucPatientId = context.state.info.ucPatientId
    if (!Wid && ucPatientId) {
      const params = {
        ucPatientId: context.state.info.ucPatientId,
        ucDoctorId: context.state.bindUser.doctorInfo.ucDoctorId
      }
      const res = await getDoingWorkOrderIdByUserId(params)
      // 默认取第一个
      if (res && res.length) {
        Wid = res[0]
      }
    }
    context.commit('SET_WORK_ID', Wid)
  },
  // 获取患者信息
  async getInfo(context, payload) {
    // 如果没有传患者id，使用state中的患者id
    const defId = context.state.patientType
      ? context.state.info.patientId
      : context.state.info.prePatientId
    const params = {
      patientId: payload?.patientId ?? defId,
      patientType: payload?.patientType ?? context.state.patientType
    }
    // 获取患者详情
    const result = await getPatientFile(params)
    context.commit('SET_INFO', result)
    // 有患者id
    const hasPatientId = !!result?.patientId
    const patientType = hasPatientId ? 1 : 0
    context.commit('SET_PATIENT_TYPE', patientType)
  },
  // 获取协同备注
  async getRemark(context) {
    const { doctorId } = context.state.bindUser.doctorInfo
    const { id: profileId } = context.state.bindUser.profileInfo
    const { patientId, prePatientId } = context.state.info
    const patientType = context.state.patientType
    // 协同备注
    const params = {
      doctorId,
      patientId: patientId || prePatientId,
      patientType: patientType,
      profileId
    }
    const res = await patientWithProfile(params)
    context.commit('SET_REMARK', res?.remarkInfoResponse || {})
  },
  async getNextFollowupTime(context) {
    const ucDoctorId = context.state.bindUser.doctorInfo.ucDoctorId
    const ucPatientId = context.state.info.ucPatientId
    if (!ucDoctorId || !ucPatientId) return
    const params = {
      ucDoctorId,
      ucPatientId
    }
    try {
      const res = await getNextFollowupInfo(params)
      context.commit('SET_NEXT_FOLLOWUP_TIME', res || {})
    } catch (error) {
      context.commit('SET_NEXT_FOLLOWUP_TIME', {})
    }
  },
  // 获取 病程阶段
  async getStage(context) {
    const { patientId, prePatientId } = context.state.info
    const { doctorId } = context.state.bindUser.doctorInfo
    const patientType = context.state.patientType
    const params = {
      doctorId,
      patientId: patientId || prePatientId,
      patientType
    }
    const res = await patientWithDoctor(params)
    context.commit('SET_DISEASE', res || {})
  },
  /**
   * 打开弹窗 提供给外部使用，如果需刷新 需要自己在业务模块下使用
    getInfo、getRemark、getStage
   * @param {object} payload {} 包含如下
   * @param必传
   * @param patientId {string}  : 患者ID（绑定关系）
   * @param patientType {number}: 患者类型 (0: 预建档患者，1: 普通患者)
   * @param非必传
   * @param profileId {string}  : 就诊人
   * @param doctorId {string}   : 医生id（绑定关系）
   * @param workOrderId {string}: 工单ID
   * @param isSubTab {boolean}: 是否子标签页（默认false）
   */
  async openModal(context, payload) {
    // NOTE: 为了处理弹窗再打开的问题，原本的没有关掉层级异常情况。
    await context.dispatch('initModal')
    !payload.isSubTab && context.commit('CLEAR_DICCTIONARY')
    context.commit('SET_STATE', 1)
    context.commit('SET_LOADING', true)
    console.log('打开患者档案-参数====>', payload)
    const patientType = payload?.patientType
    const patientId = payload?.patientId ? `${payload.patientId}` : null
    const profileId = payload?.profileId ? `${payload.profileId}` : null
    const doctorId = payload?.doctorId ? `${payload.doctorId}` : null
    const workOrderId = payload?.workOrderId
    const params = {
      patientId,
      patientType,
      profileId,
      doctorId
    }
    await context.dispatch('getInfo', params)
    await context.commit('SET_DICCTIONARY', {
      key: payload.patientId,
      value: payload
    }) // 存储多个患者档案的初始数据
    context.commit('SET_ACTIVE_PATIENT_ID', payload.patientId)
    context.commit('SET_BIND_USER', payload)
    await context.dispatch('getRemark')
    await context.dispatch('getStage')
    await context.dispatch('getWorkOrderId', workOrderId)
    await context.dispatch('getNextFollowupTime')
    context.commit('SET_LOADING', false)
  },
  // 初始化弹窗数据
  initModal(context) {
    context.commit('SET_PATIENT_TYPE', null)
    context.commit('SET_INFO', {})
    context.commit('SET_BIND_USER')
    context.commit('SET_REMARK', {})
    context.commit('SET_DISEASE', {})
    context.commit('SET_DIAGNOSIS', {})
    context.commit('SET_WORK_ID', null)
  },
  // 注入的数据记得清空
  close(context) {
    context.commit('SET_STATE', 0)
    context.commit('CLEAR_DICCTIONARY')
    context.dispatch('initModal')
    context.dispatch('resetTodoNums')
  },
  // 查看患者信息
  async handleViewArchive(context, payload) {
    const { param, callBack } = payload
    const info = context.state.info
    const { phone } = param
    if (!phone) return message.warning('缺少phone')
    const queryParam = {
      phone,
      patientId: info?.patientId || info?.prePatientId,
      patientType: context?.state?.patientType
    }
    getInfoByPhone(queryParam).then(async res => {
      const { patientId, patientType, doctorId, name } = res || {}
      if (!res || !patientId) return message.warning('该用户暂未建档，无法查看')
      const dictionary = context.state.dictionary
      // 存在则不添加
      const exist = dictionary.find(it => {
        const val = it.value
        return val?.patientId === patientId && val?.patientType === patientType
      })
      if (exist) {
        message.warning('该用户档案已打开')
        if (patientId === context.state.activePatientId) {
          callBack && callBack()
          return
        }
        // 先切换档案，再关闭模态框
        context.dispatch('changeTab', exist.value)
        // 延迟关闭模态框，确保DOM操作完成
        setTimeout(() => {
          callBack && callBack()
        }, 100)
        return
      }
      const params = {
        patientId,
        patientType,
        doctorId,
        phone,
        name
      }
      // 先打开新档案，再关闭模态框
      await context.dispatch('changeTab', params)
      setTimeout(() => {
        callBack && callBack()
      }, 100)
    })
  },
  // 切换患者档案
  changeTab(context, payload) {
    context.dispatch('openModal', { ...payload, isSubTab: true })
  },
  // 获取全部近期待办
  async getSummaryTodoAll({ commit }, payload) {
    const res = await getSummaryTodo(payload)
    const {
      prescriptionCount,
      preMedicalRecordCount,
      followupVisitCount,
      followupManageCount,
      platformCount
    } = res
    const NumsData = {
      Prescription: prescriptionCount,
      MedicalRecord: preMedicalRecordCount,
      FollowUpVisit: followupVisitCount,
      Visits: followupManageCount,
      Platform: platformCount
    }
    commit('SET_TODO_NUMS_BATCH', NumsData)
  },
  // 单个更新待办
  updateTodoNum({ commit }, { type, count }) {
    commit('SET_TODO_NUM', { type, count })
  },
  // 批量更新待办
  updateTodoNumsBatch({ commit }, newTodoNums) {
    commit('SET_TODO_NUMS_BATCH', newTodoNums)
  },
  // 重置待办
  resetTodoNums({ commit }) {
    commit('RESET_TODO_NUMS')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
